/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_edit = /** @type {(inputs: {}) => string} */ () => {
	return `Upravit`
};

const da_edit = /** @type {(inputs: {}) => string} */ () => {
	return `Rediger`
};

const de_edit = /** @type {(inputs: {}) => string} */ () => {
	return `Bearbeiten`
};

const en_edit = /** @type {(inputs: {}) => string} */ () => {
	return `Edit`
};

const es_edit = /** @type {(inputs: {}) => string} */ () => {
	return `Editar`
};

const fr_edit = /** @type {(inputs: {}) => string} */ () => {
	return `Éditer`
};

const hu_edit = /** @type {(inputs: {}) => string} */ () => {
	return `Szerkesztés`
};

const it_edit = /** @type {(inputs: {}) => string} */ () => {
	return `Modifica`
};

const nl_edit = /** @type {(inputs: {}) => string} */ () => {
	return `Bewerken`
};

const pl_edit = /** @type {(inputs: {}) => string} */ () => {
	return `Edytuj`
};

const pt_edit = /** @type {(inputs: {}) => string} */ () => {
	return `Editar`
};

const sv_edit = /** @type {(inputs: {}) => string} */ () => {
	return `Redigera`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const edit = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.edit(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("edit", locale)
	if (locale === "cs") return cs_edit(inputs)
	if (locale === "da") return da_edit(inputs)
	if (locale === "de") return de_edit(inputs)
	if (locale === "en") return en_edit(inputs)
	if (locale === "es") return es_edit(inputs)
	if (locale === "fr") return fr_edit(inputs)
	if (locale === "hu") return hu_edit(inputs)
	if (locale === "it") return it_edit(inputs)
	if (locale === "nl") return nl_edit(inputs)
	if (locale === "pl") return pl_edit(inputs)
	if (locale === "pt") return pt_edit(inputs)
	return sv_edit(inputs)
};